import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AvatarModule } from 'primeng/avatar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { PasswordModule } from 'primeng/password';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RippleModule } from 'primeng/ripple';
import { TableComponent } from './table/table.component';
import { MessageService } from 'primeng/api';
import { PaginatorModule } from 'primeng/paginator';
import { BadgeModule } from 'primeng/badge';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ChangePasswordComponent } from './change-password/change-password.component';
const primeNgModules = [
  ButtonModule,
  RippleModule,
  CardModule,
  InputTextModule,
  PasswordModule,
  DividerModule,
  BreadcrumbModule,
  TableModule,
  CheckboxModule,
  InputTextareaModule,
  TabViewModule,
  DropdownModule,
  ProgressSpinnerModule,
  TooltipModule,
  MultiSelectModule,
  ToastModule,
  AvatarModule,
  ReactiveFormsModule,
  FormsModule,
  MenuModule,
  PaginatorModule,
  BadgeModule,
  OverlayPanelModule
];


@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    TableComponent,
    ChangePasswordComponent
  ],
  imports: [...primeNgModules,CommonModule],
  providers: [
    MessageService
  ],
  exports: [...primeNgModules,HeaderComponent,SidebarComponent,TableComponent]
})
export class SharedModule { }
